import { render } from "./ServiceWorker.vue?vue&type=template&id=bac982d0"
import script from "./ServiceWorker.vue?vue&type=script&lang=js"
export * from "./ServiceWorker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__